import React, { Component } from 'react';
import LayoutPages from '../../Components/LayoutPages';
import FiltrosCorrida from '../../Components/FiltrosCorrida/FiltrosCorrida.js';
import {
    List,
    Card,
    Row,
    Col,
    DatePicker,
    Button,
    Modal,
    Divider,
    Select,
    Spin,
    Tabs
} from 'antd';
import './CorridasFinalizadas.css';
import moment from 'moment';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';

const dateFormat = 'DD/MM/YYYY';
const hourFormat = 'HH:mm';
const Option = Select.Option;
const { TabPane } = Tabs;

const corrida = {
    cdChamado: "",
    nrChamado: "",
    dtChamado: "",
    vlChamado: "",
    dsEnderecoOrigem: "",
    dsEnderecoDestino: "",
    dsStatus: "",
    dsFormaPagamento: "",
    dsMotorista: ""
}

class CorridasFinalizadas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalVisible: false,
            modalFiltroVisible: false,
            corridaSelecionada: corrida,
            listData: [],
            listaChamadosResumido: [],
            loadingData: false,
            loadingDataResumo: false,
            checkedKeys: [],
            dataInicial: moment(),
            dataFinal: moment(),
            obsStatus: [],
            obStatusSelecionado: { "cdStatus": -1, "dsStatus": "Todos" },
            vlMedioCorrida: 0,
            qtdChamados: 0,
            vlTotalCorridaFinalizada: 0,
            paginacao: {
                inicial: 1,
                final: 50,
                habilitado: false
            }
        }
        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
        this.usuario = this.dadosProvider.getDadosUsuario();

        this.botaoVerMaisRef = React.createRef();
    };

    componentWillMount() {
        this.getComboStatus();
    }

    handleClickLink = (selecionada) => {
        this.corridaSelected = selecionada;
        this.setState({ corridaSelecionada: selecionada });

        this.showModal();
    };

    showModal = () => {
        this.setState({
            modalVisible: true,
        });
    }

    handleCancel = (e) => {
        console.log(e);
        this.setState({
            modalVisible: false,
        });
    }

    showModalFiltro = () => {
        this.setState({
            modalFiltroVisible: true,
        });
    }

    handleFiltroCancel = (e) => {
        console.log(e);
        this.setState({
            modalFiltroVisible: false,
        });
    }

    handleFiltroOk = () => {
        this.resetarPaginacao(()=>{
            this.setState({
                modalFiltroVisible: false,
            });
    
            this.loadItens(true);
            this.getListaChamadoResumoPwa();
        });
    }

    onSelectDataInicial = (value) => {
        this.setState({ dataInicial: value });
    }

    onSelectDataFinal = (value) => {
        this.setState({ dataFinal: value });
    }

    onCheckKey(checkedKeys) {
        this.setState({ checkedKeys });
    }

    loadItens(limparDados) {
        const botaoVerMais = this.botaoVerMaisRef.current;
        const offsetTopAntes = botaoVerMais && !limparDados ? botaoVerMais.buttonNode.offsetTop : null;

        var veiculo = "";
        var motoristas = "";

        for (var i in this.state.checkedKeys) {
            var chave = this.state.checkedKeys[i];

            if (chave.charAt(0) == "V") {
                veiculo = chave.substr(1);
            } else {
                motoristas += chave.substr(1) + ",";
            }
        }

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        if (veiculo == "" && motoristas == "") {
            veiculo = usuario.UiPessoa;
            motoristas = usuario.UiPessoa;
        }

        var ini = moment(this.state.dataInicial.format("YYYY-MM-DD"));
        var fim = moment(this.state.dataFinal.format("YYYY-MM-DD"));
        var qtdMeses = ini.diff(fim, "months") * -1;

        var stSituacao = 1;
        if (qtdMeses <= 2)
            stSituacao = 2;
        else if (qtdMeses > 2)
            stSituacao = 3;

        var dados = {
            "uiFilial": filial,
            "uiPessoaVeiculos": veiculo,
            "uiPessoaMotoristas": motoristas,
            "dtInicial": `${this.state.dataInicial.format("DD/MM/YYYY")}`,
            "dtFinal": `${this.state.dataFinal.format("DD/MM/YYYY")}`,
            "stSituacao": `${stSituacao}`,
            "cdStatus": this.state.obStatusSelecionado.cdStatus,
            "nrInicial": this.state.paginacao.inicial,
            "nrFinal": this.state.paginacao.final
        };


        this.setState({ loadingData: true });
        this.dataService.ListaChamadoPwa(dados, (retorno) => {
            const novosItens = retorno.map(dado => ({
                cdChamado: dado['cdChamado'],
                nrChamado: dado['nrChamado'],
                dtChamado: dado['dtChamado'],
                vlChamado: parseFloat(dado['vlChamado']).toFixed(2),
                dsEnderecoOrigem: dado['dsEnderecoOrigem'],
                dsEnderecoDestino: dado['dsEnderecoDestino'],
                dsStatus: dado['dsStatus'],
                dsFormaPagamento: dado['dsFormaPagamento'],
                dsMotorista: dado['dsMotorista'],
                vlParaSomar: dado['vlParaSomar']
            }));

            const itensAntigos = limparDados ? [] : this.state.listData;

            let vlTotalCorridas = 0;
            let vlTotalCorridasFinalizadas = 0;

            retorno.forEach(dado => {
                vlTotalCorridas += parseFloat(dado['vlChamado']);
                vlTotalCorridasFinalizadas += parseFloat(dado['vlParaSomar']);
            });

            this.getListaTotaisChamadoPwa(dados);

            this.setState({
                listData: itensAntigos.concat(novosItens),
                loadingData: false,
                vlTotalCorridas,
                vlTotalCorridasFinalizadas,
                paginacao: {
                    ...this.state.paginacao,
                    habilitado: novosItens.length > 0
                }
            }, () => {
                // Após renderizar, volta pro mesmo offset do botão
                if (offsetTopAntes !== null) {
                    setTimeout(() => {
                        var header = document.getElementsByTagName("header")[0];
                        if(header){
                            header.parentElement.scrollTo({
                                top: offsetTopAntes,
                                behavior: 'auto'
                            });
                        }
                    }, 100);
                }
            });

        }, (erro) => {
            console.error(erro);
            this.setState({ loadingData: false });
        });
    }

    onStatusChange = (value) => {
        console.log("status", this.state.obsStatus);
        this.setState({
            obStatusSelecionado: this.state.obsStatus[value]
        })
    }

    getComboStatus = () => {

        var dados = {
            "uiFilial": this.dadosProvider.getUiFilial(),
            "cripto": this.dadosProvider.getDadosUsuario().Cripto,
            "cdsStatus": "0,5"
        };

        this.setState({ buscando: true });

        var obs = [{ "cdStatus": -1, "dsStatus": "Todos" }];

        this.dataService.ListaStatus(dados, (retorno) => {

            if (retorno.length > 0) {
                obs = [...obs, ...retorno];

                this.setState({ buscando: false, obsStatus: obs, obStatusSelecionado: obs[0] });
            }

        }, (erro) => {
            console.error(erro);
            this.setState({ buscando: false, obsStatus: obs });
        });
    }

    getListaTotaisChamadoPwa = (dados) => {
        this.setState({ buscando: true });

        this.dataService.ListaTotaisChamadoPwa(dados, (retorno) => {
            console.log(retorno);
            if (retorno.length > 0) {

                let qtdChamados = isNaN(retorno[0].qtdChamados) ? 0 : parseInt(retorno[0].qtdChamados);
                let vlMedioCorrida = isNaN(retorno[0].vlMedioCorrida) ? 0 : parseFloat(retorno[0].vlMedioCorrida);
                let vlTotalCorridaFinalizada = isNaN(retorno[0].vlTotalCorridaFinalizada) ? 0 : parseFloat(retorno[0].vlTotalCorridaFinalizada)

                this.setState({
                    buscando: false,
                    qtdChamados: qtdChamados,
                    vlMedioCorrida: vlMedioCorrida,
                    vlTotalCorridaFinalizada: vlTotalCorridaFinalizada,
                });
            }

        }, (erro) => {
            console.error(erro);
            this.setState({ buscando: false });
        });
    }

    getListaChamadoResumoPwa() {
        var veiculo = "";
        var motoristas = "";

        for (var i in this.state.checkedKeys) {
            var chave = this.state.checkedKeys[i];

            if (chave.charAt(0) == "V") {
                veiculo = chave.substr(1);
            } else {
                motoristas += chave.substr(1) + ",";
            }
        }

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        if (veiculo == "" && motoristas == "") {
            veiculo = usuario.UiPessoa;
            motoristas = usuario.UiPessoa;
        }

        var ini = moment(this.state.dataInicial.format("YYYY-MM-DD"));
        var fim = moment(this.state.dataFinal.format("YYYY-MM-DD"));
        var qtdMeses = ini.diff(fim, "months") * -1;

        var stSituacao = 1;
        if (qtdMeses <= 2)
            stSituacao = 2;
        else if (qtdMeses > 2)
            stSituacao = 3;

        var dados = {
            "uiFilial": filial,
            "uiPessoaVeiculos": veiculo,
            "uiPessoaMotoristas": motoristas,
            "dtInicial": `${this.state.dataInicial.format("DD/MM/YYYY")}`,
            "dtFinal": `${this.state.dataFinal.format("DD/MM/YYYY")}`,
            "stSituacao": `${stSituacao}`,
            "cdStatus": this.state.obStatusSelecionado.cdStatus
        };

        this.setState({ loadingDataResumo: true });
        this.dataService.ListaChamadoResumoPwa(dados, (retorno) => {
            var newData = [];

            if (retorno.length > 0) {
                for (var i in retorno) {
                    var dado = retorno[i];

                    newData.push({
                        dsFormaPagamento: dado['dsFormaPagamento'],
                        vlTotal: parseFloat(dado['vlTotal']).toFixed(2)
                    });
                }
            }

            this.setState({
                listaChamadosResumido: newData,
                loadingDataResumo: false
            });

        }, (erro) => {
            console.log(erro);
            this.setState({ loadingDataResumo: false });
        });
    }

    resetarPaginacao(callback = ()=>{}) {
        this.setState({
            paginacao: {
                inicial: 1,
                final: 50
            }
        }, callback);
    }

    handleVerMais = () => {
        const itensPorPagina = 50;
        this.setState({
            paginacao: {
                habilitado: false,
                inicial: this.state.paginacao.final + 1,
                final: this.state.paginacao.final + 1 + itensPorPagina
            }
        }, () => {
            this.loadItens(false);
        });
    }

    render() {

        const header = (
            <Card className="hidden-sm">
                <Row gutter={6}>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>QRU</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Data</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Motorista</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Origem</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Destino</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Forma de Pagamento</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Status</strong>
                    </Col>
                    <Col xs={0} sm={0} md={3} lg={3} xl={3}>
                        <strong>Valor</strong>
                    </Col>
                </Row>
            </Card>
        );

        const headerResumo = (
            <Card className="hidden-sm">
                <Row gutter={6}>
                    <Col xs={0} md={12}>
                        <strong>Forma de Pagamento</strong>
                    </Col>
                    <Col xs={0} md={12}>
                        <strong>Total</strong>
                    </Col>
                </Row>
            </Card>
        );

        return (

            <LayoutPages pageTitle="Corridas Finalizadas" history={this.props.history} pageIndex="2">

                <div className="corridasFinalizadas">

                    <Modal
                        title="Detalhes da corrida"
                        visible={this.state.modalVisible}
                        onCancel={this.handleCancel}
                        footer={null}
                    >
                        {this.state.modalVisible ? (
                            <div>
                                <p>
                                    <strong>QRU: </strong>{this.state.corridaSelecionada.nrChamado} <br />
                                    <strong>Data: </strong>{this.state.corridaSelecionada.dtChamado} <br />
                                    <strong>Motorista: </strong>{this.state.corridaSelecionada.dsMotorista} <br />
                                    <strong>Origem: </strong>{this.state.corridaSelecionada.dsEnderecoOrigem} <br />
                                    <strong>Destino: </strong>{this.state.corridaSelecionada.dsEnderecoDestino} <br />
                                    <strong>Forma de pagamento: </strong>{this.state.corridaSelecionada.dsFormaPagamento} <br />
                                    <strong>Status: </strong>{this.state.corridaSelecionada.dsStatus} <br />
                                    <strong>Valor: </strong>{this.state.corridaSelecionada.vlChamado} <br />
                                </p>
                            </div>
                        ) : ""}
                    </Modal>

                    <Modal
                        title="Filtros"
                        visible={this.state.modalFiltroVisible}
                        onCancel={this.handleFiltroCancel}
                        onOk={this.handleFiltroOk}
                    >
                        {this.state.modalFiltroVisible ? (
                            <FiltrosCorrida onCheckKey={this.onCheckKey.bind(this)} checkedKeys={this.state.checkedKeys} />
                        ) : ""}
                    </Modal>

                    <div>
                        <Divider orientation="left">Filtros</Divider>

                        <Row gutter={6}>
                            <Col xs={12} sm={6} md={5} lg={3} xl={3}>
                                Data inicial:
                                <DatePicker defaultValue={moment()} style={{ width: '100%' }} format={dateFormat} onChange={this.onSelectDataInicial} />
                            </Col>
                            <Col xs={12} sm={6} md={5} lg={3} xl={3}>
                                Data final:
                                <DatePicker defaultValue={moment()} style={{ width: '100%' }} format={dateFormat} onChange={this.onSelectDataFinal} />
                            </Col>
                            <Col xs={12} sm={6} md={5} lg={3} xl={3}>
                                Status:
                                <Select style={{ width: '100%' }}
                                    defaultValue={["Todos"]}
                                    onChange={this.onStatusChange}>
                                    {this.state.obsStatus.map((obStatus, index) => <Option key={index}>{obStatus["dsStatus"]}</Option>)}
                                </Select>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                                <br />
                                <Button
                                    icon="bars"
                                    onClick={() => this.showModalFiltro()}
                                    style={{ backgroundColor: '#b9b9b9', color: '#fff', width: '100%' }}>Filtros</Button>
                            </Col>
                            <Col xs={24} sm={24} md={5} lg={3} xl={3}>
                                <br />
                                <Button type="primary" style={{ width: '100%' }} icon="search" onClick={this.handleFiltroOk}>Filtrar</Button>
                            </Col>
                        </Row>
                        <Divider />
                        <Row gutter={[6, 6]}>
                            <Col xs={24} sm={12} lg={8}>
                                <Card>
                                    <h1 className="mb-0">Corridas Realizadas</h1>
                                    <span className="fs-3">{this.state.qtdChamados}</span>
                                </Card>
                            </Col>
                            <Col xs={24} sm={12} lg={8}>
                                <Card>
                                    <h1 className="mb-0">Valor Médio por Corrida</h1>
                                    <span className="fs-3">{this.usuario.DsMoedaPadrao} {this.state.vlMedioCorrida.toFixed(2)}</span>
                                </Card>
                            </Col>
                            <Col xs={24} sm={24} lg={8}>
                                <Card>
                                    <h1 className="mb-0">Valor Total de Corridas Finalizadas</h1>
                                    <span className="fs-3">{this.usuario.DsMoedaPadrao} {this.state.vlTotalCorridaFinalizada.toFixed(2)}</span>
                                </Card>
                            </Col>
                        </Row>
                        <Divider />

                    </div>

                    <Tabs defaultActiveKey="1" onChange={() => { }}>
                        <TabPane tab="Completo" key="1">
                            {this.state.loadingData ? (
                                <div className="loadingData">
                                    Carregando <br /><br />
                                    <Spin />
                                </div>
                            ) : (
                                <List
                                    itemLayout="vertical"
                                    size="large"
                                    header={header}
                                    dataSource={this.state.listData}
                                    className="tbCorridasFinalizadas"
                                    renderItem={item => (
                                        <List.Item onClick={() => this.handleClickLink(item)} key={item.id}>

                                            <Card>
                                                <Row gutter={6}>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">QRU:</strong> {item.nrChamado}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">Data:</strong> {item.dtChamado}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">Motorista:</strong> {item.dsMotorista}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={34}>
                                                        <strong className="hidden-md">Origem:</strong> {item.dsEnderecoOrigem}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">Destino:</strong> {item.dsEnderecoDestino}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">Forma de pagamento:</strong> {item.dsFormaPagamento}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">Status:</strong> {item.dsStatus}
                                                    </Col>
                                                    <Col xs={24} sm={24} md={3} lg={3} xl={3}>
                                                        <strong className="hidden-md">Valor:</strong> {item.vlChamado}
                                                    </Col>
                                                </Row>

                                            </Card>

                                        </List.Item>
                                    )}
                                />
                            )}
                            <Button
                                ref={this.botaoVerMaisRef}
                                type="primary"
                                style={{ width: '100%', marginTop: '15px', marginBottom: '15px' }}
                                icon="plus"
                                onClick={this.handleVerMais}
                                disabled={!this.state.paginacao.habilitado || this.state.loadingData}
                            >
                                Ver Mais
                            </Button>

                        </TabPane>
                        <TabPane tab="Por Formas de Pagamento" key="2">
                            {this.state.loadingDataResumo ? (
                                <div className="loadingData">
                                    Carregando <br /><br />
                                    <Spin />
                                </div>
                            ) : (
                                <List
                                    itemLayout="vertical"
                                    size="large"
                                    header={headerResumo}
                                    dataSource={this.state.listaChamadosResumido}
                                    className="tbCorridasFinalizadasResumo"
                                    renderItem={item => (
                                        <List.Item>
                                            <Card>
                                                <Row gutter={6}>
                                                    <Col xs={24} md={12}>
                                                        <strong className="hidden-md">Forma de Pagamento:</strong> {item.dsFormaPagamento}
                                                    </Col>
                                                    <Col xs={24} md={12}>
                                                        <strong className="hidden-md">Total:</strong>{this.usuario.DsMoedaPadrao} {item.vlTotal}
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </List.Item>
                                    )}
                                />
                            )}
                        </TabPane>
                    </Tabs>
                </div>

            </LayoutPages>
        )
    }
}

export default CorridasFinalizadas;


// WEBPACK FOOTER //
// ./src/Pages/CorridasFinalizadas/CorridasFinalizadas.js